module.exports = __webpack_public_path__ + "img/6_uk.6c4d9a8d.svg";